import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HeaderPublic from '../../components/Header/HeaderPublic';
import Footer from './../../components/Footer';
import { TrendingUp, AlertTriangle, FileText, DollarSign, Percent, BarChart2, Shield, Award, Calculator, Star, PieChart } from 'lucide-react';

const BasicEducation = () => {
  const educationCategories = [
    {
      title: 'Yeniden Dengeleme',
      description: 'Portföyünüzü düzenli olarak dengelemeyi öğrenin',
      path: '/egitim/yeniden-dengeleme-rehberi',
      icon: <TrendingUp className="h-8 w-8 text-blue-500" />
    },
    {
      title: 'Yatırım Hataları',
      description: 'Yaygın yatırım hatalarından kaçınmayı öğrenin',
      path: '/egitim/yatirim-hatalari',
      icon: <AlertTriangle className="h-8 w-8 text-yellow-500" />
    },
    {
      title: 'Bilanço ve Kâr-Zarar Tablosu',
      description: 'Finansal tabloları okumayı ve analiz etmeyi öğrenin',
      path: '/egitim/bilanco-kar-zarar-tablosu',
      icon: <FileText className="h-8 w-8 text-green-500" />
    },
    {
      title: 'Hisse Başına Kazanç',
      description: 'Şirketlerin kazanç performansını değerlendirmeyi öğrenin',
      path: '/egitim/hisse-basina-kazanc',
      icon: <DollarSign className="h-8 w-8 text-indigo-500" />
    },
    {
      title: 'Faiz Oranlarının Etkisi',
      description: 'Faiz oranlarının piyasalara etkisini anlayın',
      path: '/egitim/faiz-oranlarinin-etkisi',
      icon: <Percent className="h-8 w-8 text-red-500" />
    },
    {
      title: 'Ekonomik Göstergeler',
      description: 'Önemli ekonomik göstergeleri yorumlamayı öğrenin',
      path: '/egitim/ekonomik-gostergeler',
      icon: <BarChart2 className="h-8 w-8 text-purple-500" />
    },
    {
      title: 'Risk Toleransı',
      description: 'Kendi risk toleransınızı anlamayı ve yönetmeyi öğrenin',
      path: '/egitim/risk-toleransi',
      icon: <Shield className="h-8 w-8 text-orange-500" />
    },
    {
      title: 'Piotroski Puanı',
      description: 'Şirket değerlemesinde Piotroski skorunu kullanmayı öğrenin',
      path: '/egitim/piotroski-puani',
      icon: <Award className="h-8 w-8 text-cyan-500" />
    },
    {
      title: 'Formüller',
      description: 'Temel finansal formülleri öğrenin',
      path: '/egitim/finansal-formuller',
      icon: <Calculator className="h-8 w-8 text-pink-500" />
    },
    {
      title: 'ETF\'ler',
      description: 'ETF\'lerin çalışma mantığını ve avantajlarını öğrenin',
      path: '/egitim/etfs',
      icon: <Star className="h-8 w-8 text-amber-500" />
    },
    {
      title: 'Temel Finansal Oranlar',
      description: 'Şirketleri değerlendirmede kullanılan temel oranları öğrenin',
      path: '/egitim/temel-finansal-oranlar',
      icon: <PieChart className="h-8 w-8 text-emerald-500" />
    }
  ];

  return (
    <>
      <Helmet>
        <title>Temel Bilgiler| Smart Portfoy</title>
        <meta name="description" content="Finans ve yatırım dünyasında kendinizi geliştirmek için temel eğitimlerimize göz atın." />
      </Helmet>

      <div className="min-h-screen bg-gray-800 text-gray-100">
        <HeaderPublic />
        
        {/* Container için daha fazla üst boşluk (padding-top) ekledik */}
        <div className="container mx-auto px-4 py-12 pt-24 max-w-7xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
              Temel Bilgiler
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Finansal yatırımlar hakkında bilmeniz gereken temel konuları keşfedin ve başarılı bir yatırımcı olmak için gerekli bilgilere ulaşın.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {educationCategories.map((category, index) => (
              <Link 
                key={index}
                to={category.path}
                className="bg-gray-750 hover:bg-gray-700 border border-gray-700 rounded-lg p-6 transition-all duration-300 hover:shadow-lg hover:shadow-blue-900/20 hover:-translate-y-1"
              >
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-gray-800 rounded-lg">
                    {category.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-blue-400 mb-2">{category.title}</h3>
                    <p className="text-gray-300">{category.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default BasicEducation;